import { Box, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useEffect, useMemo, useState } from "react";
import { depositStake } from "../../../services/depositStake";
import { mirarStake } from "../../../services/mirarStake";
import { useDispatch, useSelector } from "react-redux";
import { retiroStake } from "../../../services/retiroStake";
import { getCookie } from "../../../utils/getCookies";
import { rutas } from "../../../rutas/rutas";
import { setInformacion } from "../../../store/slices/usuarios";
import { Alerta } from "../../ux/Alert";
import axios from "axios";

const FALLBACK_ITEMS = [
  {
    item: "Water",
    pointsPerUnit: 1,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680463586/CITYFARMING/agua_ay1q7p.png",
  },
  {
    item: "Energy",
    pointsPerUnit: 0.5,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680992031/CITYFARMING/assets/rayo_b1cspv.png",
  },
  {
    item: "Wood",
    pointsPerUnit: 1,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680463588/CITYFARMING/madera_hvpf5a.png",
  },
  {
    item: "Carbon",
    pointsPerUnit: 0.25,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680463586/CITYFARMING/carbon_epy7k7.png",
  },
  {
    item: "Wheat",
    pointsPerUnit: 1,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1681670271/CITYFARMING/assets%20wallet/image_1_prgglk.png",
  },
  {
    item: "Corn",
    pointsPerUnit: 1,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1681670270/CITYFARMING/assets%20wallet/image_u7r7pw.png",
  },
  {
    item: "Corn Bag",
    pointsPerUnit: 2,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680727644/CITYFARMING/image_2_wzvgtv.png",
  },
  {
    item: "Wheat Bag",
    pointsPerUnit: 2,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680727644/CITYFARMING/image_3_imgniw.png",
  },
  {
    item: "Egg",
    pointsPerUnit: 3,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680463586/CITYFARMING/huevo_fiyzsu.png",
  },
  {
    item: "Milk",
    pointsPerUnit: 3,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680463588/CITYFARMING/leche_ekdu14.png",
  },
  {
    item: "VIPHUESO",
    pointsPerUnit: 0.05,
    weeklyMax: 200,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680992031/CITYFARMING/assets/rayo_b1cspv.png",
  },
  {
    item: "HUESO",
    pointsPerUnit: 0.0005,
    weeklyMax: 20000,
    url: "https://res.cloudinary.com/devuvyuij/image/upload/v1680992031/CITYFARMING/assets/rayo_b1cspv.png",
  },
];

const ITEM_ORDER = [
  "Water",
  "Energy",
  "Corn",
  "Wheat",
  "Corn Bag",
  "Wheat Bag",
  "Egg",
  "Milk",
  "Wood",
  "Carbon",
  "VIPHUESO",
  "HUESO",
];

const TEXT = {
  es: {
    title: "Stake SWAP.HIVE",
    subtitle:
      "Deposita recursos, acumula puntos y participa en recompensas semanales con una vista moderna y clara.",
    weeklyPool: "Pool semanal",
    ranking: "Clasificación",
    rankingSub: "Jugadores ordenados por puntos",
    player: "Jugador",
    points: "Puntos",
    rank: "Puesto",
    depositTitle: "Depositar en Stake",
    inventory: "Inventario",
    yourPoints: "Tus puntos",
    quantity: "Cantidad",
    conversion: "Conversión",
    weeklyLimit: "Límite semanal",
    pointsToAdd: "Puntos a agregar",
    depositButton: "Depositar",
    withdrawButton: "Retirar recompensa",
    rewardTitle: "Resumen de recompensas",
    available: "SWAP.HIVE disponible",
    nextReward: "Próxima recompensa estimada",
    totalPool: "Pool total disponible",
    weeklyDistribution: "Distribución semanal",
    minWithdraw: "Retiro mínimo",
    nextPayout: "Próximo pago",
    lastReward: "Último pago registrado",
    noRewards: "Sin pagos registrados todavía",
    monthlyCut: "Reducción mensual de puntos",
    monthlyCutText:
      "El día 1 se reduce 75% de tus puntos. Tus recompensas acumuladas en SWAP.HIVE no se eliminan.",
    important: "Importante",
    importantText:
      "Los recursos depositados se convierten definitivamente en puntos y no pueden retirarse.",
    removedItems:
      "Puedes quemar Water y Energy en Stake: Water = 1 punto y Energy = 0,5 puntos por unidad.",
    recovered: "Recuperación histórica aplicada",
    success: "Operación completada",
    pointsShort: "pts",
    activeAssets: "Activos habilitados",
    depositFailed: "No se pudo completar el depósito en Stake.",
    retryHint: "Revisa el saldo del recurso e inténtalo nuevamente.",
    depositSuccess: "Depósito realizado",
    remainingResource: "Saldo restante",
    runtimeLabel: "Diagnóstico",
    thisWeek: "Esta semana",
    weeklyPoints: "Puntos aportados",
    weeklyOperations: "Depósitos realizados",
    weeklyAssets: "Recursos depositados",
    projectedReward: "Recompensa proyectada",
    withdrawalProgress: "Progreso para retiro",
    readyToWithdraw: "Listo para retirar",
    remainingToWithdraw: "Faltan",
    noWeeklyDeposits: "Aún no has depositado recursos esta semana.",
  },
  en: {
    title: "SWAP.HIVE Stake",
    subtitle:
      "Deposit resources, gain points, and participate in weekly rewards with a modern and clear view.",
    weeklyPool: "Weekly pool",
    ranking: "Leaderboard",
    rankingSub: "Players sorted by points",
    player: "Player",
    points: "Points",
    rank: "Rank",
    depositTitle: "Deposit to Stake",
    inventory: "Inventory",
    yourPoints: "Your points",
    quantity: "Quantity",
    conversion: "Conversion",
    weeklyLimit: "Weekly limit",
    pointsToAdd: "Points to add",
    depositButton: "Deposit",
    withdrawButton: "Withdraw reward",
    rewardTitle: "Rewards summary",
    available: "Available SWAP.HIVE",
    nextReward: "Estimated next reward",
    totalPool: "Total pool available",
    weeklyDistribution: "Weekly distribution",
    minWithdraw: "Minimum withdrawal",
    nextPayout: "Next payout",
    lastReward: "Last recorded payout",
    noRewards: "No payouts recorded yet",
    monthlyCut: "Monthly point reduction",
    monthlyCutText:
      "On day 1, 75% of your points are reduced. Your accumulated SWAP.HIVE rewards are not deleted.",
    important: "Important",
    importantText:
      "Deposited resources are permanently converted into points and cannot be withdrawn.",
    removedItems:
      "Water and Energy can be burned in Stake: Water = 1 point and Energy = 0.5 points per unit.",
    recovered: "Historical recovery applied",
    success: "Operation completed",
    pointsShort: "pts",
    activeAssets: "Enabled assets",
    depositFailed: "The Stake deposit could not be completed.",
    retryHint: "Check the resource balance and try again.",
    depositSuccess: "Deposit completed",
    remainingResource: "Remaining balance",
    runtimeLabel: "Diagnostics",
    thisWeek: "This week",
    weeklyPoints: "Points contributed",
    weeklyOperations: "Deposits made",
    weeklyAssets: "Deposited resources",
    projectedReward: "Projected reward",
    withdrawalProgress: "Withdrawal progress",
    readyToWithdraw: "Ready to withdraw",
    remainingToWithdraw: "Remaining",
    noWeeklyDeposits: "You have not deposited resources this week yet.",
  },
};

const UI_REVISION = "stake-ui-water-energy-restored-2026-10-26";
const FONT = '"Segoe UI", Tahoma, Arial, sans-serif';
const BG = "#062b18";
const CARD_BG = "#0c3820";
const BORDER = "1px solid rgba(219, 175, 43, .62)";
const SHADOW = "0 12px 34px rgba(0,0,0,.28)";

function detectLanguage() {
  try {
    const saved = window.localStorage.getItem("cityfarm-v2-language-v6");
    return saved === "en" ? "en" : "es";
  } catch (_) {
    return "es";
  }
}

function sanitizeStakeItems(rows = []) {
  const list = rows.filter((row) => row?.item);

  return [...list].sort((a, b) => {
    const ia = ITEM_ORDER.indexOf(a.item);
    const ib = ITEM_ORDER.indexOf(b.item);
    const va = ia === -1 ? 999 : ia;
    const vb = ib === -1 ? 999 : ib;

    if (va !== vb) return va - vb;
    return String(a.item).localeCompare(String(b.item));
  });
}

function nextWeeklyPayoutUtc() {
  const now = new Date();
  const candidate = new Date(now);
  const day = candidate.getUTCDay();
  const daysUntilMonday = (8 - day) % 7;

  candidate.setUTCDate(candidate.getUTCDate() + daysUntilMonday);
  candidate.setUTCHours(0, 3, 0, 0);

  if (candidate <= now) {
    candidate.setUTCDate(candidate.getUTCDate() + 7);
  }

  return candidate;
}

function formatUtc(date, language) {
  if (!date) return "—";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "—";

  return (
    new Intl.DateTimeFormat(language === "es" ? "es-ES" : "en-US", {
      timeZone: "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(d) + " UTC"
  );
}

function formatNumber(value, digits = 4) {
  const n = Number(value || 0);
  if (!Number.isFinite(n)) return "0";

  return n.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
}

function SectionCard({ children, sx }) {
  return (
    <Box
      sx={{
        background: CARD_BG,
        border: BORDER,
        borderRadius: "11px",
        boxShadow: SHADOW,
        p: 1.5,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

function StatTile({ label, value, accent = "#fff6cf" }) {
  return (
    <Box
      sx={{
        background: "#123d24",
        border: "1px solid rgba(113, 169, 119, .65)",
        borderRadius: "999px",
        px: 1.4,
        py: 0.8,
        minWidth: 128,
        flex: "0 1 auto",
      }}
    >
      <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#cfe6d5", lineHeight: 1.1 }}>
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 900,
          color: accent,
          mt: 0.2,
          lineHeight: 1.15,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

const inputStyle = {
  width: "100%",
  minHeight: 46,
  borderRadius: 8,
  border: "1px solid rgba(103, 151, 108, .82)",
  background: "#092818",
  color: "#ffffff",
  padding: "0 14px",
  fontFamily: FONT,
  fontSize: 15,
  fontWeight: 700,
  outline: "none",
  boxSizing: "border-box",
};

const primaryButtonStyle = {
  minHeight: 44,
  borderRadius: 8,
  border: "1px solid rgba(255, 206, 108, .34)",
  background: "#d9aa22",
  color: "#112719",
  fontFamily: FONT,
  fontSize: 15,
  fontWeight: 800,
  padding: "0 16px",
  cursor: "pointer",
  boxShadow: "0 10px 18px rgba(0,0,0,.16)",
};

const secondaryButtonStyle = {
  minHeight: 44,
  borderRadius: 8,
  border: "1px solid rgba(171, 255, 198, .26)",
  background: "#164d2c",
  color: "#eafff1",
  fontFamily: FONT,
  fontSize: 15,
  fontWeight: 800,
  padding: "0 16px",
  cursor: "pointer",
  boxShadow: "0 10px 18px rgba(0,0,0,.14)",
};

export const Stake = () => {
  const [cantidad, setCantidad] = useState("");
  const [item, setItem] = useState("Corn");
  const [data, setData] = useState([]);
  const [me, setMe] = useState({ puntos: 0, cantidad: 0 });
  const [pool, setPool] = useState(0);
  const [config, setConfig] = useState({
    weeklyDistributionPercent: 2,
    monthlyPointBurnPercent: 75,
    minWithdrawal: 0.1,
    items: FALLBACK_ITEMS,
  });
  const [stats, setStats] = useState({
    weeklyPool: 0,
    estimatedWeeklyReward: 0,
  });
  const [recentRewards, setRecentRewards] = useState([]);
  const [recoveryRows, setRecoveryRows] = useState([]);
  const [language, setLanguage] = useState(detectLanguage);
  const [apiRevision, setApiRevision] = useState("not-detected");
  const [runtimeInfo, setRuntimeInfo] = useState(null);

  const { informacion } = useSelector((state) => state.userSlice);
  const dispatch = useDispatch();

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const tr = TEXT[language];

  const items = useMemo(() => {
    const source = config?.items?.length ? config.items : FALLBACK_ITEMS;
    return sanitizeStakeItems(source);
  }, [config]);

  useEffect(() => {
    if (!items.length) return;
    if (!items.find((row) => row.item === item)) {
      setItem(items[0].item);
    }
  }, [items, item]);

  const selectedItem = useMemo(
    () => items.find((row) => row.item === item) || items[0] || null,
    [items, item]
  );

  const quantityNumber = Number(cantidad || 0);
  const pointsToAdd =
    quantityNumber > 0
      ? quantityNumber * Number(selectedItem?.pointsPerUnit || 0)
      : 0;

  const handleClose = () => setOpen(false);

  const handleInfo = () => {
    const tokenJWT = getCookie("token");
    if (!tokenJWT) return;

    axios
      .get(`${rutas.getUsuario}`, { headers: { token: tokenJWT } })
      .then(({ data: userData }) => dispatch(setInformacion(userData)))
      .catch((err) => console.log(err));
  };

  const getStake = async () => {
    try {
      const res = await mirarStake();
      const payload = res?.data || {};
      setApiRevision(String(payload?.revision || "legacy-no-revision"));
      const sorted = [...(payload.stake || [])].sort(
        (a, b) => Number(b?.puntos || 0) - Number(a?.puntos || 0)
      );

      setData(sorted);
      setPool(Number(payload?.pool?.cantidad || 0));
      setConfig(payload?.config || config);
      setStats(
        payload?.stats || {
          weeklyPool: Number(payload?.pool?.cantidad || 0) * 0.02,
          estimatedWeeklyReward: 0,
        }
      );
      setRecentRewards(payload?.recentRewards || []);
      setRecoveryRows(payload?.recoveryRows || []);

      if (payload?.me) {
        setMe(payload.me);
      } else {
        const fallbackMe = sorted.find(
          (row) => String(row?.id || "") === String(informacion?._id || "")
        );
        setMe(fallbackMe || { puntos: 0, cantidad: 0 });
      }
    } catch (stakeError) {
      console.error("[STAKE FRONT] load error:", stakeError);
    }
  };

  const retirar = async () => {
    try {
      await retiroStake();
      await getStake();
      handleInfo();
      setError(false);
      setMensaje(tr.success);
      setOpen(true);
    } catch (withdrawError) {
      setError(true);
      setOpen(true);
      setMensaje(
        withdrawError?.response?.data?.error || "Stake withdrawal error"
      );
    }
  };

  const deposito = async () => {
    try {
      if (!selectedItem) return;
      if (!Number.isInteger(quantityNumber) || quantityNumber <= 0) return;

      const response = await depositStake(item, quantityNumber);
      const payload = response?.data || {};

      setCantidad("");
      await getStake();
      handleInfo();

      setError(false);
      setMensaje(
        `${tr.depositSuccess}: +${formatNumber(payload?.pointsAdded, 4)} ${tr.pointsShort}. ` +
          `${tr.remainingResource}: ${formatNumber(payload?.remainingResource, 4)} ${item}.`
      );
      setOpen(true);
    } catch (depositError) {
      setError(true);
      setOpen(true);
      const backendMessage = depositError?.response?.data?.error;
      const backendCode = depositError?.response?.data?.code;

      const backendStage = depositError?.response?.data?.stage;
      const backendDebug = depositError?.response?.data?.debug;
      const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);

      if (backendCode === "STAKE_DEPOSIT_FAILED" && isLocal && backendDebug?.message) {
        setMensaje(
          `${tr.depositFailed} [${backendStage || "unknown"}] ${backendDebug.message}`
        );
      } else if (backendCode === "STAKE_DEPOSIT_FAILED") {
        setMensaje(`${tr.depositFailed} ${tr.retryHint}`);
      } else {
        setMensaje(backendMessage || tr.depositFailed);
      }
    }
  };

  useEffect(() => {
    const root = document.querySelector(".cfv2-stake-root");
    const panel = root?.closest(".cfv2-real-panel");

    if (!panel) return undefined;

    const styleId = "cfv2-stake-force-wide-style";
    let style = document.getElementById(styleId);

    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        .cfv2-real-panel.cfv2-stake-force-wide {
          width: min(96vw, 1540px) !important;
          max-width: 1540px !important;
          height: 94vh !important;
          max-height: 94vh !important;
        }

        @media (max-width: 1100px) {
          .cfv2-real-panel.cfv2-stake-force-wide {
            width: 98vw !important;
            height: 96vh !important;
            max-height: 96vh !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    panel.classList.add("cfv2-stake-force-wide");

    return () => {
      panel.classList.remove("cfv2-stake-force-wide");
    };
  }, []);

  useEffect(() => {
    getStake();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let active = true;
    axios
      .get(rutas.runtimeInfo, { timeout: 3000 })
      .then(({ data }) => {
        if (active) setRuntimeInfo(data || null);
      })
      .catch(() => {
        if (active) setRuntimeInfo(null);
      });
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    const interval = window.setInterval(() => {
      const next = detectLanguage();
      setLanguage((current) => (current === next ? current : next));
    }, 500);

    return () => window.clearInterval(interval);
  }, []);

  const inventoryRows = [
    ...(informacion?.inventario || []),
    { item: "VIPHUESO", cantidad: informacion?.viphueso || 0 },
    { item: "HUESO", cantidad: informacion?.hueso || 0 },
  ];

  const inventoryAmount =
    inventoryRows.find((row) => row?.item === item)?.cantidad || 0;

  const lastReward = recentRewards?.[0];
  const recoveredTotal = recoveryRows.reduce(
    (sum, row) => sum + Number(row?.recoveredAmount || 0),
    0
  );
  const minimumWithdrawal = Number(config?.minWithdrawal || 0.1);
  const availableReward = Math.max(0, Number(me?.cantidad || 0));
  const withdrawalPercent =
    minimumWithdrawal > 0
      ? Math.min(100, (availableReward / minimumWithdrawal) * 100)
      : 100;
  const withdrawalRemaining = Math.max(
    0,
    minimumWithdrawal - availableReward
  );

  const weeklyDepositEntries = Object.entries(
    stats?.weeklyDepositsByItem || {}
  )
    .filter(([, value]) => Number(value || 0) > 0)
    .sort((a, b) => Number(b[1] || 0) - Number(a[1] || 0));

  const showRuntime = ["localhost", "127.0.0.1"].includes(window.location.hostname);

  return (
    <Box
      className="cfv2-stake-root"
      sx={{
        width: "100%",
        height: "100%",
        p: 1,
        color: "#ffffff",
        fontFamily: FONT,
        "&, & *": {
          fontFamily: `${FONT} !important`,
          letterSpacing: "normal !important",
          textTransform: "none !important",
          boxSizing: "border-box",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "12px",
          border: "2px solid #d9aa22",
          background: BG,
          boxShadow: "0 24px 70px rgba(0,0,0,.42)",
          p: 1.25,
          pr: 0.8,
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarGutter: "stable",
          scrollBehavior: "smooth",
          scrollbarWidth: "auto",
          scrollbarColor: "#d9aa22 #082817",
          "&::-webkit-scrollbar": {
            width: "14px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#082817",
            borderLeft: "1px solid rgba(217,170,34,.24)",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "linear-gradient(180deg, #f4cf5b 0%, #b77d14 100%)",
            border: "3px solid #082817",
            borderRadius: "999px",
            minHeight: "54px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "linear-gradient(180deg, #ffe680 0%, #d99f22 100%)",
          },
        }}
      >
        <Box
          className="cfv2-stake-scroll-hint"
          sx={{
            position: "sticky",
            top: 2,
            zIndex: 20,
            display: "flex",
            justifyContent: "flex-end",
            pointerEvents: "none",
            height: 0,
            pr: 0.5,
          }}
        >
          <Box
            sx={{
              px: 0.8,
              py: 0.35,
              borderRadius: "999px",
              border: "1px solid rgba(217,170,34,.42)",
              background: "rgba(8,40,23,.92)",
              color: "#ffe083",
              fontSize: 11,
              fontWeight: 900,
              lineHeight: 1,
              opacity: 0.82,
            }}
          >
            ↕
          </Box>
        </Box>

        <SectionCard sx={{ mb: 1.75, p: 1.8 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Box sx={{ flex: "1 1 320px" }}>
              <Typography sx={{ fontSize: 25, fontWeight: 900, lineHeight: 1.15, color: "#ffe083" }}>
                {tr.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  lineHeight: 1.55,
                  color: "#d7eee0",
                  fontWeight: 600,
                  mt: 0.5,
                  maxWidth: 740,
                }}
              >
                {tr.subtitle}
              </Typography>
              {showRuntime ? (
                <Typography
                  sx={{
                    display: "inline-block",
                    mt: 0.65,
                    px: 0.8,
                    py: 0.3,
                    border: "1px solid rgba(156,232,255,.45)",
                    borderRadius: "6px",
                    background: "rgba(14,60,74,.45)",
                    color: "#c9f4ff",
                    fontSize: 11,
                    fontWeight: 800,
                  }}
                >
                  {tr.runtimeLabel}: UI {UI_REVISION} · API {apiRevision} · runtime {runtimeInfo?.runtime || "not-detected"}
                </Typography>
              ) : null}
            </Box>

            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", flex: "1 1 320px", justifyContent: "flex-end" }}>
              <StatTile
                label={tr.weeklyPool}
                value={formatNumber(stats?.weeklyPool ?? pool * 0.02, 5)}
              />
              <StatTile
                label={tr.yourPoints}
                value={formatNumber(me?.puntos, 2)}
                accent="#b8ffd0"
              />
              <StatTile
                label={tr.available}
                value={formatNumber(me?.cantidad, 4)}
                accent="#9ce8ff"
              />
            </Box>
          </Box>
        </SectionCard>

        <Grid2 container spacing={1.75} sx={{ minHeight: "calc(100% - 126px)", height: "auto", alignItems: "stretch" }}>
          <Grid2 xs={12} md={4} sx={{ minHeight: 0 }}>
            <SectionCard sx={{ height: "auto", maxHeight: "72vh", display: "flex", flexDirection: "column", minHeight: 0 }}>
              <Box sx={{ mb: 1.2 }}>
                <Typography sx={{ fontSize: 20, fontWeight: 900, color: "#ffe083" }}>
                  {tr.ranking}
                </Typography>
                <Typography sx={{ fontSize: 14, color: "#d7eee0", fontWeight: 600, mt: 0.35 }}>
                  {tr.rankingSub}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "grid",
                  gap: 1,
                  overflow: "auto",
                  pr: 0.5,
                  minHeight: 0,
                  flex: 1,
                }}
              >
                {data.map((row, idx) => (
                  <Box
                    key={String(row?._id || row?.id || row?.nombre || idx)}
                    sx={{
                      background: "#12452a",
                      border: "1px solid rgba(218, 174, 42, .72)",
                      borderRadius: "10px",
                      px: 1.35,
                      py: 1.15,
                      boxShadow: "inset 0 1px 0 rgba(255,255,255,.03)",
                      display: "grid",
                      gridTemplateColumns: "52px minmax(0,1fr) auto",
                      alignItems: "center",
                      gap: 1.1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 42,
                        height: 42,
                        borderRadius: "50%",
                        background:
                          idx === 0
                            ? "linear-gradient(180deg, #ffd76a 0%, #d5a022 100%)"
                            : idx === 1
                            ? "linear-gradient(180deg, #d8e1eb 0%, #9eadbb 100%)"
                            : idx === 2
                            ? "linear-gradient(180deg, #ffbf85 0%, #c87c2c 100%)"
                            : "linear-gradient(180deg, rgba(255,255,255,.16) 0%, rgba(255,255,255,.06) 100%)",
                        color: idx <= 2 ? "#233528" : "#ffffff",
                        display: "grid",
                        placeItems: "center",
                        fontWeight: 900,
                        fontSize: 16,
                        boxShadow: "inset 0 1px 0 rgba(255,255,255,.15)",
                      }}
                    >
                      #{idx + 1}
                    </Box>

                    <Box sx={{ minWidth: 0 }}>
                      <Typography sx={{ fontSize: 16, fontWeight: 900, color: "#ffffff" }}>
                        {row?.nombre || "—"}
                      </Typography>
                      <Typography sx={{ fontSize: 13, color: "#d8eadf", fontWeight: 600, mt: 0.25 }}>
                        {tr.points}: {formatNumber(row?.puntos, 2)} {tr.pointsShort}
                      </Typography>
                    </Box>

                    <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#ffe18c" }}>
                      {tr.rank} #{idx + 1}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </SectionCard>
          </Grid2>

          <Grid2 xs={12} md={8} sx={{ minHeight: 0 }}>
            <Box sx={{ height: "auto", display: "grid", gridTemplateRows: "auto auto auto", gap: 1.75, minHeight: 0 }}>
              <SectionCard sx={{ p: 1.5 }}>
                <Box sx={{ display: "flex", gap: 1.2, alignItems: "center", flexWrap: "wrap", mb: 1.1 }}>
                  {selectedItem?.url ? (
                    <Box
                      sx={{
                        width: 46,
                        height: 46,
                        borderRadius: "9px",
                        background: "#092818",
                        border: BORDER,
                        display: "grid",
                        placeItems: "center",
                        flex: "0 0 auto",
                      }}
                    >
                      <img
                        src={selectedItem.url}
                        alt={selectedItem.item}
                        style={{ width: 32, height: 32, imageRendering: "pixelated" }}
                      />
                    </Box>
                  ) : null}

                  <Box sx={{ flex: "1 1 280px" }}>
                    <Typography sx={{ fontSize: 20, fontWeight: 900, color: "#ffe083" }}>
                      {tr.depositTitle}
                    </Typography>
                    <Typography sx={{ fontSize: 14, color: "#d7eee0", fontWeight: 600, mt: 0.35 }}>
                      {tr.inventory}: <b>{formatNumber(inventoryAmount, 4)}</b>
                      {" · "}
                      {tr.yourPoints}: <b>{formatNumber(me?.puntos, 2)}</b>
                    </Typography>
                  </Box>
                </Box>

                <Grid2 container spacing={1.1}>
                  <Grid2 xs={12} md={6}>
                    <select
                      value={item}
                      onChange={(e) => setItem(e.target.value)}
                      style={inputStyle}
                    >
                      {items.map((row) => (
                        <option key={row.item} value={row.item}>
                          {row.item}
                        </option>
                      ))}
                    </select>
                  </Grid2>

                  <Grid2 xs={12} md={6}>
                    <input
                      value={cantidad}
                      onChange={(e) => setCantidad(e.target.value)}
                      style={inputStyle}
                      type="number"
                      min={1}
                      step={1}
                      placeholder={tr.quantity}
                    />
                  </Grid2>
                </Grid2>

                <Box
                  sx={{
                    mt: 1.1,
                    display: "grid",
                    gap: 1,
                    gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" },
                  }}
                >
                  <Box sx={{ background: "rgba(255,255,255,.05)", border: BORDER, borderRadius: "9px", p: 1.1 }}>
                    <Typography sx={{ fontSize: 12, color: "#cfe6d8", fontWeight: 700 }}>
                      {tr.conversion}
                    </Typography>
                    <Typography sx={{ fontSize: 16, fontWeight: 900, mt: 0.25 }}>
                      1 {selectedItem?.item || "—"} = {formatNumber(selectedItem?.pointsPerUnit, 4)} {tr.pointsShort}
                    </Typography>
                  </Box>

                  <Box sx={{ background: "rgba(255,255,255,.05)", border: BORDER, borderRadius: "9px", p: 1.1 }}>
                    <Typography sx={{ fontSize: 12, color: "#cfe6d8", fontWeight: 700 }}>
                      {tr.pointsToAdd}
                    </Typography>
                    <Typography sx={{ fontSize: 18, fontWeight: 900, mt: 0.25, color: "#ffe18c" }}>
                      {formatNumber(pointsToAdd, 4)}
                    </Typography>
                  </Box>

                  <Box sx={{ background: "rgba(255,255,255,.05)", border: BORDER, borderRadius: "9px", p: 1.1 }}>
                    <Typography sx={{ fontSize: 12, color: "#cfe6d8", fontWeight: 700 }}>
                      {tr.weeklyLimit}
                    </Typography>
                    <Typography sx={{ fontSize: 16, fontWeight: 900, mt: 0.25 }}>
                      {selectedItem?.weeklyMax
                        ? `${formatNumber(selectedItem.weeklyMax, 0)} ${selectedItem.item}`
                        : "—"}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1.2 }}>
                  <button
                    onClick={deposito}
                    disabled={!selectedItem || !Number.isInteger(quantityNumber) || quantityNumber <= 0}
                    style={{
                      ...primaryButtonStyle,
                      opacity:
                        !selectedItem || !Number.isInteger(quantityNumber) || quantityNumber <= 0 ? 0.6 : 1,
                      cursor:
                        !selectedItem || !Number.isInteger(quantityNumber) || quantityNumber <= 0
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    {tr.depositButton}
                  </button>

                  {Number(me?.cantidad || 0) >= Number(config?.minWithdrawal || 0.1) ? (
                    <button onClick={retirar} style={secondaryButtonStyle}>
                      {tr.withdrawButton}
                    </button>
                  ) : null}
                </Box>
              </SectionCard>

              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                <StatTile label={tr.activeAssets} value={items.length} accent="#ffffff" />
                <StatTile label={tr.minWithdraw} value={`${formatNumber(config?.minWithdrawal || 0.1, 2)} SWAP.HIVE`} accent="#ffe18c" />
                <StatTile label={tr.weeklyDistribution} value={`${config?.weeklyDistributionPercent || 2}%`} accent="#9ce8ff" />
              </Box>

              <SectionCard
                sx={{
                  minHeight: 0,
                  height: "auto",
                  overflow: "visible",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <Typography sx={{ fontSize: 20, fontWeight: 900, color: "#ffe083", mb: 1.15 }}>
                  {tr.rewardTitle}
                </Typography>

                <div
                  style={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: "0px",
                    border: "1px solid rgba(219,175,43,.35)",
                    borderRadius: "9px",
                    background: "#103d25",
                    overflow: "hidden",
                  }}
                >
                  {[
                    [tr.available, `${formatNumber(me?.cantidad, 5)} SWAP.HIVE`, "#b8ffd0"],
                    [tr.nextReward, `${formatNumber(stats?.estimatedWeeklyReward, 5)} SWAP.HIVE`, "#9ce8ff"],
                    [tr.totalPool, formatNumber(pool, 5), "#ffe18c"],
                    [tr.weeklyDistribution, `${config?.weeklyDistributionPercent || 2}%`, "#ffffff"],
                    [tr.minWithdraw, `${formatNumber(config?.minWithdrawal || 0.1, 2)} SWAP.HIVE`, "#ffffff"],
                    [tr.nextPayout, formatUtc(nextWeeklyPayoutUtc(), language), "#ffffff"],
                    [
                      tr.lastReward,
                      lastReward
                        ? `${formatNumber(lastReward.reward, 5)} SWAP.HIVE`
                        : tr.noRewards,
                      "#ffffff",
                    ],
                  ].map(([label, value, color], index) => (
                    <div
                      key={`${label}-${index}`}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "minmax(0, 1fr) auto",
                        alignItems: "center",
                        gap: "18px",
                        padding: "11px 13px",
                        borderBottom:
                          index === 6 ? "none" : "1px solid rgba(255,255,255,.08)",
                        fontFamily: FONT,
                      }}
                    >
                      <span
                        style={{
                          color: "#d8eadf",
                          fontSize: "14px",
                          fontWeight: 700,
                          lineHeight: 1.35,
                        }}
                      >
                        {label}
                      </span>
                      <span
                        style={{
                          color,
                          fontSize: index === 0 ? "17px" : "14px",
                          fontWeight: 900,
                          lineHeight: 1.35,
                          textAlign: "right",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {value}
                      </span>
                    </div>
                  ))}

                  {recoveredTotal > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "minmax(0, 1fr) auto",
                        alignItems: "center",
                        gap: "18px",
                        padding: "11px 13px",
                        borderTop: "1px solid rgba(184,255,208,.22)",
                        background: "rgba(41,109,65,.22)",
                        fontFamily: FONT,
                      }}
                    >
                      <span style={{ color: "#b8ffd0", fontSize: "14px", fontWeight: 800 }}>
                        {tr.recovered}
                      </span>
                      <span style={{ color: "#b8ffd0", fontSize: "14px", fontWeight: 900 }}>
                        {formatNumber(recoveredTotal, 5)} SWAP.HIVE
                      </span>
                    </div>
                  ) : null}
                </div>

                <Box
                  sx={{
                    mt: 1.15,
                    display: "grid",
                    gap: 1,
                    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                  }}
                >
                  <Box
                    sx={{
                      border: "1px solid rgba(219,175,43,.35)",
                      borderRadius: "9px",
                      background: "#103d25",
                      p: 1.2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        fontWeight: 900,
                        color: "#ffe083",
                        mb: 0.9,
                      }}
                    >
                      {tr.thisWeek}
                    </Typography>

                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "minmax(0,1fr) auto",
                        gap: 0.75,
                        alignItems: "center",
                      }}
                    >
                      <Typography sx={{ fontSize: 13, color: "#d8eadf", fontWeight: 700 }}>
                        {tr.weeklyPoints}
                      </Typography>
                      <Typography sx={{ fontSize: 15, color: "#b8ffd0", fontWeight: 900 }}>
                        {formatNumber(stats?.weeklyDepositedPoints, 4)} {tr.pointsShort}
                      </Typography>

                      <Typography sx={{ fontSize: 13, color: "#d8eadf", fontWeight: 700 }}>
                        {tr.weeklyOperations}
                      </Typography>
                      <Typography sx={{ fontSize: 15, color: "#ffffff", fontWeight: 900 }}>
                        {formatNumber(stats?.weeklyDepositOperations, 0)}
                      </Typography>

                      <Typography sx={{ fontSize: 13, color: "#d8eadf", fontWeight: 700 }}>
                        {tr.projectedReward}
                      </Typography>
                      <Typography sx={{ fontSize: 15, color: "#9ce8ff", fontWeight: 900 }}>
                        {formatNumber(stats?.estimatedWeeklyReward, 5)} SWAP.HIVE
                      </Typography>
                    </Box>

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#cfe6d8",
                        fontWeight: 800,
                        mt: 1.05,
                        mb: 0.6,
                      }}
                    >
                      {tr.weeklyAssets}
                    </Typography>

                    {weeklyDepositEntries.length ? (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.6 }}>
                        {weeklyDepositEntries.map(([asset, amount]) => (
                          <Box
                            key={asset}
                            sx={{
                              px: 0.8,
                              py: 0.45,
                              borderRadius: "999px",
                              border: "1px solid rgba(184,255,208,.25)",
                              background: "rgba(41,109,65,.24)",
                              color: "#eaffef",
                              fontSize: 12,
                              fontWeight: 800,
                            }}
                          >
                            {asset}: {formatNumber(amount, 4)}
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Typography sx={{ fontSize: 12, color: "#a9c9b5", fontWeight: 600 }}>
                        {tr.noWeeklyDeposits}
                      </Typography>
                    )}
                  </Box>

                  <Box
                    sx={{
                      border: "1px solid rgba(156,232,255,.28)",
                      borderRadius: "9px",
                      background: "#0d3825",
                      p: 1.2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        fontWeight: 900,
                        color: "#ffe083",
                        mb: 0.9,
                      }}
                    >
                      {tr.withdrawalProgress}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 1,
                        mb: 0.65,
                      }}
                    >
                      <Typography sx={{ fontSize: 13, color: "#d8eadf", fontWeight: 700 }}>
                        {formatNumber(availableReward, 5)} / {formatNumber(minimumWithdrawal, 2)} SWAP.HIVE
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 13,
                          color: withdrawalPercent >= 100 ? "#b8ffd0" : "#9ce8ff",
                          fontWeight: 900,
                        }}
                      >
                        {formatNumber(withdrawalPercent, 1)}%
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        height: 12,
                        width: "100%",
                        borderRadius: "999px",
                        overflow: "hidden",
                        background: "rgba(0,0,0,.28)",
                        border: "1px solid rgba(255,255,255,.08)",
                      }}
                    >
                      <Box
                        sx={{
                          height: "100%",
                          width: `${withdrawalPercent}%`,
                          minWidth: withdrawalPercent > 0 ? "4px" : 0,
                          background:
                            withdrawalPercent >= 100
                              ? "linear-gradient(90deg, #7cf09a 0%, #c9ff9a 100%)"
                              : "linear-gradient(90deg, #6bd8ff 0%, #b7f3ff 100%)",
                          transition: "width .25s ease",
                        }}
                      />
                    </Box>

                    <Typography
                      sx={{
                        mt: 0.8,
                        fontSize: 12.5,
                        color: withdrawalPercent >= 100 ? "#b8ffd0" : "#d8eadf",
                        fontWeight: 800,
                      }}
                    >
                      {withdrawalPercent >= 100
                        ? tr.readyToWithdraw
                        : `${tr.remainingToWithdraw}: ${formatNumber(withdrawalRemaining, 5)} SWAP.HIVE`}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "grid", gap: 1, mt: 1.15 }}>
                  <Box
                    sx={{
                      borderRadius: "9px",
                      border: "1px solid rgba(255, 183, 107, .26)",
                      background: "rgba(104, 56, 22, .18)",
                      p: 1.15,
                    }}
                  >
                    <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#ffe3c1" }}>
                      {tr.monthlyCut}
                    </Typography>
                    <Typography sx={{ fontSize: 13.5, lineHeight: 1.55, color: "#fff7ee", mt: 0.45, fontWeight: 600 }}>
                      {tr.monthlyCutText}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      borderRadius: "9px",
                      border: "1px solid rgba(158, 255, 194, .22)",
                      background: "rgba(24, 84, 48, .18)",
                      p: 1.15,
                    }}
                  >
                    <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#cbffd6" }}>
                      {tr.important}
                    </Typography>
                    <Typography sx={{ fontSize: 13.5, lineHeight: 1.55, color: "#f5fff7", mt: 0.45, fontWeight: 600 }}>
                      {tr.importantText}
                    </Typography>
                    <Typography sx={{ fontSize: 13.5, lineHeight: 1.55, color: "#cbffd6", mt: 0.45, fontWeight: 700 }}>
                      {tr.removedItems}
                    </Typography>
                  </Box>
                </Box>
              </SectionCard>
            </Box>
          </Grid2>
        </Grid2>
      </Box>

      <Alerta mensaje={mensaje} open={open} handleClose={handleClose} error={error} />
    </Box>
  );
};
